// Angular
import { Component, Input, OnInit } from '@angular/core';

// Afidium
import { Yii } from 'libraries/interfaces/Yii';

import { ICurrency } from 'libraries/service/resources/model/search/ICurrency';
import { IRoomDetail, RoomStatus } from 'libraries/hotel/models/quote';
import { IConfigSharedHotel } from 'libraries/hotel/models/config-shared-hotel';
import { ICurrencies } from 'libraries/service/resources/hotel/ISearchResponse';
import { IResortFeeDetail, ISalesInformation } from 'libraries/service/resources/model/search/IBooking';

//lib
import { faCheck, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import {PermissionResourceService} from "../../../service/resources/permission/permissionResource.service";

class WordingClass {
    public readonly cost: string = Yii.t('wui-iqbh-js', 'Prix d\'achat');
    public readonly retail: string = Yii.t('wui-iqbh-js', 'Prix de vente');
}

@Component({
    selector: 'room',
    templateUrl: './room.component.html',
    styleUrls: ['./room.component.scss']
})
export class RoomComponent implements OnInit {
    public Yii = Yii;
    public readonly wording: WordingClass = new WordingClass();

    @Input()
    public currency: ICurrency;

    @Input()
    public currencies: ICurrencies;

    @Input()
    public configSharedHotel: IConfigSharedHotel;

    @Input()
    public room: IRoomDetail;

    @Input()
    public oldRoom: IRoomDetail;

    @Input()
    public roomNumber: number;

    @Input()
    public showMealPlan: boolean = false;

    @Input()
    public travellers: {
        [key: string]: {
            adult?: number;
            child?: number;
            infant?: number;
        }
    };

    @Input()
    public selectedRoom: boolean = false;

    @Input()
    public resortFee: IResortFeeDetail;

    @Input()
    public salesInformation: ISalesInformation;

    public RoomStatus: typeof RoomStatus = RoomStatus;
    public showRetailPricePermission: boolean = false;
    public showCostPricePermission: boolean = false;

    public travellersByRoom;

    public iconCheck: IconDefinition = faCheck;

    constructor(
        private readonly permissionResource: PermissionResourceService) {
    }


    public ngOnInit(): void {
        this.permissionResource.getPermissionsStartingWith(['shared', 'stay', 'price']).subscribe((permissions: Set<string>) => {
            this.showRetailPricePermission = permissions.has('shared.stay.price.retail.show');
            this.showCostPricePermission = permissions.has('shared.stay.price.cost.show');
        });
        this.travellersByRoom = this.getTravellersDistribution(`R${this.roomNumber}`);
    }

    public getTravellersDistribution(room: string): string {
        let distributionText = '';

        if (this.travellers && this.travellers[room]) {
            if (this.travellers[room].adult > 0) {
                distributionText += this.travellers[room].adult + ' ADT ';
            }

            if (this.travellers[room].child > 0) {
                distributionText += this.travellers[room].child + ' CHD ';
            }

            if (this.travellers[room].infant > 0) {
                distributionText += this.travellers[room].infant + ' INF ';
            }
        }

        return distributionText;
    }

}
